"use client";

import { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: containerRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [parallaxOffset, setParallaxOffset] = useState(0);
  const imageRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (imageRef.current) {
        const rect = imageRef.current.getBoundingClientRect();
        const scrollProgress = Math.max(0, Math.min(1, 1 - rect.top / window.innerHeight));
        setParallaxOffset(scrollProgress * 40);
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section ref={containerRef} className="min-h-screen bg-light-background text-foreground-light flex items-center py-16 px-4 md:px-8 lg:px-16">
      <div className="max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        {}
        <div className={`flex flex-col items-center lg:items-start text-center lg:text-left space-y-6 transition-all duration-[250ms] ease-[cubic-bezier(0.25,0.46,0.45,0.94)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-sans font-bold leading-tight text-foreground-light">
            From Concept to Commercialization — Your End-to-End Product & Technical Partner
          </h1>
          
          <p className="text-lg md:text-xl text-muted max-w-xl">
            We help companies develop high-performance products, accelerate innovation, and make confident technical decisions.
          </p>

          <div className="pt-4 flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
            <Link to="/ContactPage">
              <Button className="btn-primary text-base md:text-lg px-8 py-6 relative overflow-hidden group w-full sm:w-auto">
                <span className="relative z-10">Schedule a Consultation</span>
                <span className="absolute inset-0 bg-accent-hover opacity-0 group-hover:opacity-100 transition-opacity duration-[250ms]" />
              </Button>
            </Link>

            <Link to="/ServicesPage">
              <Button className="btn-primary text-base md:text-lg px-8 py-6 relative overflow-hidden group w-full sm:w-auto">
                <span className="relative z-10">Explore Our Services</span>
                <span className="absolute inset-0 bg-accent-hover opacity-0 group-hover:opacity-100 transition-opacity duration-[250ms]" />
              </Button>
            </Link>
          </div>
        </div>

        {}
        <div ref={imageRef} className={`relative transition-all duration-[250ms] ease-[cubic-bezier(0.25,0.46,0.45,0.94)] delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <div className="relative rounded-lg overflow-hidden shadow-strong" style={{
          transform: `translateY(${parallaxOffset}px)`,
          transition: "transform 0.1s linear"
        }}>
            <img src="https://famous-marmoset.10web.cloud/wp-content/uploads/2026/04/landing_hero_2.jpg" alt="Flex DPS Product Prototype" className="w-full h-auto object-cover" />
          </div>
        </div>
      </div>
    </section>;
}